'use client';

import { Product } from '@/lib/shopify/types';
import Image from 'next/image';
import Price from '@/components/price';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { getRelatedProducts } from './actions';

export default function RelatedProducts() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      try {
        setLoading(true);
        const relatedProducts = await getRelatedProducts();
        setProducts(relatedProducts);
      } catch (error) {
        console.error('Error fetching related products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRelatedProducts();
  }, []);

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-black" />
      </div>
    );
  }

  if (!products.length) {
    return null;
  }

  return (
    <div className="flex h-full w-full flex-col">
      <h3 className="mb-4 text-base font-semibold text-black dark:text-white">You might also like</h3>
      <ul className="flex flex-col gap-6 overflow-auto">
        {products.map((product) => (
          <li key={product.id} className="flex flex-col">
            <Link href={`/product/${product.handle}`} className="group">
              <div className="relative h-38 w-full overflow-hidden rounded-md border border-neutral-300 bg-neutral-300 dark:border-neutral-700 dark:bg-neutral-900">
                {product.featuredImage && (
                  <Image
                    src={product.featuredImage.url}
                    alt={product.featuredImage.altText || product.title}
                    fill
                    sizes="(max-width: 768px) 100vw, 250px"
                    className="object-cover transition-all duration-200 group-hover:scale-105"
                  />
                )}
              </div>
              <div className="mt-2 flex flex-col">
                <h4 className="text-sm font-medium text-black truncate dark:text-white" title={product.title}>{product.title}</h4>
                <Price
                  className="mt-1 text-sm text-black dark:text-white"
                  amount={product.priceRange.minVariantPrice.amount}
                  currencyCode={product.priceRange.minVariantPrice.currencyCode}
                />
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
} 